// src/VideoPlayer.js

import React, { useRef, useEffect, useState } from 'react';
import './VideoPlayer.css';

const VideoPlayer = ({ src }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      var playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(_ => {
          // Automatic playback started!
          // Show playing UI.
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
        });
      }
      // video.play();
    }
  }, []);

  const handlePlayPause = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const handleMuteUnmute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  return (
    <div className="video-container">
      <video ref={videoRef} className="custom-video" autoPlay muted loop>
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-controls">
        <button onClick={handlePlayPause}>
          <i className={isPlaying ? 'fas fa-pause' : 'fas fa-play'}></i>
        </button>
        <button onClick={handleMuteUnmute}>
          <i className={isMuted ? 'fas fa-volume-mute' : 'fas fa-volume-up'}></i>
        </button>
      </div>
    </div>
  );
};

export default VideoPlayer;
